export const ciColors = {
  white: "#ffffff",
  black: "#262626",

  superLightGrey: "#ededf3",
  veryLightGrey: "#dedee0",
  lightGrey: "#a9aabc",
  mediumGrey: "#a9aabc",
  darkGrey: "#454555",
  veryDarkGrey: "#454555",

  purple: "#863b8b",
  pink: "#d24d7f",
  darkSalmon: "#f2685a",
  salmon: "#ff7b68",
  orange: "#ffb859",
  yellow: "#f9f871",

  darkBlue: "#003480",
  blue: "#6B7CD3",
  lightBlue: "#C2CDFF",

  darkGreen: "#007d58",
  green: "#00b38a",
  lightGreen: "#5cecc0"
};

export const appColors = {
  fontPrimary: ciColors.black,
  fontSecondary: ciColors.mediumGrey,
  backgroundPrimary: ciColors.white,
  backgroundSecondary: ciColors.veryLightGrey,
  highlight: ciColors.darkSalmon,
  inputOutline: ciColors.darkBlue,
  buttonFont: ciColors.white,
  buttonBackground: ciColors.darkSalmon,
};
